import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SEO from "../../Common/SEO";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import NewsPreviewContnet from "./NewsPreviewContnet";
import NewsPreviewNav from "./NewsPreviewNav";
import NewsPreviewStatic from "./NewsPreviewStatic";
import NewsPreviewTags from "./NewsPreviewTags";
import NewsPreviewTitle from "./NewsPreviewTitle";
import { SESSION_AUTH } from "../../../common/auth";
import { NEWS_SERVICES } from "../../../services";
import "./style.scss";

const NewsPreview = () => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const { orgSlug, urlSlug } = useParams();
  const [postContent, setPostContent] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [postKeywords, setPostKeywords] = useState("");
  const [postDate, setPostDate] = useState("");
  const [postImage, setPostImage] = useState("");
  const [postCategory, setPostCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const dataFetched = useRef(false);
  const [postSummary, setPostSummary] = useState("");
  const [readTime, setReadTime] = useState("");
  const [postUrl, setPostUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (dataFetched.current || !urlSlug) return;
    dataFetched.current = true;
    const query = new URLSearchParams(window.location.search);
    const nu_e_k = query.get("nu_e_k");

    setLoading(true);
    NEWS_SERVICES.detail({
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      urlSlug: urlSlug,
      orgSlug: orgSlug,
      nu_e_k: nu_e_k,
    })
      .then(data => {
        if (data.code === 200) {
          setPostSummary(data?.data?.summary);
          setReadTime(
            data?.data?.readTime > 1
              ? `${data?.data?.readTime} min read`
              : "Less than 1 min read"
          );
          setPostTitle(data?.data?.title);
          setPostKeywords(data?.data?.keywords);
          setPostDate(data?.data?.date);
          setPostImage(data?.data?.contentImage);
          setPostCategory(data?.data?.category);
          setPostUrl(window.location.href);
          setPostContent(data?.data?.content);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({
            title: data?.message,
          });
          navigate(`/company/${orgSlug}/news`);
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    urlSlug,
    orgSlug,
    isUserSession,
    LOGOUT_USER_SESSION,
    dataFetched,
    navigate,
  ]);

  return loading ? (
    <FullPageProgress fixed={true} />
  ) : postTitle ? (
    <React.Fragment>
      <SEO
        title={postTitle}
        url={postUrl}
        description={postSummary}
        postImage={postImage}
      />

      <div className="events6ix-layout-page-middle">
        <NewsPreviewNav orgSlug={orgSlug} postTitle={postTitle} />
        <NewsPreviewStatic
          postTime={postDate}
          readTime={readTime}
          category={postCategory}
        />
        <NewsPreviewTitle postTitle={postTitle} />

        <div className="com-divider w-100"></div>
        <NewsPreviewContnet postImage={postImage} content={postContent} />
        <NewsPreviewTags tags={postKeywords} />
      </div>
    </React.Fragment>
  ) : (
    <FullPageProgress />
  );
};

export default NewsPreview;
